import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

import { AuthShell } from '../../components/admin/AuthShell';
import { api, errorMessage } from '../../lib/api';

export function AdminVerifyPage() {
  const [sp] = useSearchParams();
  const token = sp.get('token') ?? '';
  const [status, setStatus] = useState<'pending' | 'ok' | 'error'>('pending');
  const [msg, setMsg] = useState('');

  useEffect(() => {
    void (async () => {
      try {
        await api.post('/admin/auth/verify-email', { token });
        setStatus('ok');
      } catch (err) {
        setStatus('error');
        setMsg(errorMessage(err));
      }
    })();
  }, [token]);

  return (
    <AuthShell title={status === 'pending' ? 'Verifying…' : status === 'ok' ? 'Email confirmed' : 'Verification failed'}>
      {status === 'ok' && (
        <p>
          You can now{' '}
          <Link to="/admin/login" className="text-navy-900 underline">
            sign in
          </Link>
          .
        </p>
      )}
      {status === 'error' && <p className="text-lacquer">{msg}</p>}
    </AuthShell>
  );
}
